import React from "react";

function Error(props) {
  var { errorCode, error } = props;
  if (!error) {
    if (errorCode == 404) {
      error = (
        <div className="text-lg text-gray-800 tracking-widest">
          Page Not Found
        </div>
      );
    }
  }
  return (
    <div className="h-screen w-full flex items-center justify-center flex-col">
      <div className="font-bold block text-6xl">{errorCode}</div>
      {error}
    </div>
  );
}

export default Error;
